import { onLoad } from 'utils/on_load'

onLoad(() => {
  // Automatically clicks the first element found with the `data-js-click-me` attribute.
  const clickMe = document.querySelector("[data-js-click-me]")

  // Avoid clicking more than once in case the event is fired again.
  if (clickMe && clickMe.dataset.jsClickMe === '') {
    clickMe.dataset.jsClickMe = false
    clickMe.click()
  }
})
